import { render } from "./DPageTitle.vue?vue&type=template&id=3669a66e&scoped=true&ts=true"
import script from "./DPageTitle.vue?vue&type=script&lang=ts"
export * from "./DPageTitle.vue?vue&type=script&lang=ts"

import "./DPageTitle.vue?vue&type=style&index=0&id=3669a66e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3669a66e"]])

export default __exports__